import { Component, Input, OnInit } from '@angular/core';
import { LetterRequestCustomer_Cancel } from 'src/app/Interface/LetterRequestCustomer_Cancel';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';

@Component({
  selector: 'app-LetterRequestCustomerMissionActivityRelative',
  templateUrl: './LetterRequestCustomerMissionActivityRelative.component.html',
  styleUrls: ['./LetterRequestCustomerMissionActivityRelative.component.scss']
})
export class LetterRequestCustomerMissionActivityRelativeComponent implements OnInit {


  @Input() inner_Schedule_id: number = 0
  Filter_Letter: String = ""
  Procssing:boolean=false

  constructor(
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
    this.ReadData_Schedules()
  }


  SubmitSchedulesRelative(){
    this.Procssing=true
    this.LetterRequestCustomer_Service.SubmitSchedulesRelative(Number(this.Filter_Letter),this.inner_Schedule_id).subscribe(
      data=>{
        this.Procssing=false
        if(data['id']==-1)
        {
          this.Alertify_Service.ErrorMessage("شماره حکم ماموریت معتبر نمی باشد")
        }
        else{
          this.Alertify_Service.SuccessMessage("اتصال اعمال شد")
          this.ReadData_Schedules()
        }
      }
    )
  }

  DataList_Schedules:Array<LetterRequestCustomer_Cancel>=[]
  ReadData_Schedules(){
    this.Procssing=true

    this.LetterRequestCustomer_Service.GetSchedulesRelative(this.inner_Schedule_id).subscribe(
      data=>{
        this.DataList_Schedules=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  RemoveSchedulesRelative(){
    this.Procssing=true
    this.LetterRequestCustomer_Service.RemoveSchedulesRelative(this.inner_Schedule_id).subscribe(
      data=>{
        this.Procssing=false
        if(data['id']==-1)
        {
          this.Alertify_Service.ErrorMessage("امکان حذف این اتصال وجود ندارد")
        }
        else{
          this.Alertify_Service.SuccessMessage("اتصال حذف شد")
          this.ReadData_Schedules()
        }
      }
    )
  }


}
